import { ChangeDetectionStrategy, Component, EventEmitter, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BiTranslateDirective } from "@globals/bi-translate";
import { RadioButtonModule } from "primeng/radiobutton";

@Component({
  selector: "bi-archive-messages-map-toggle.component",
  templateUrl: "./bi-archive-messages-map-toggle.component.html",
  styleUrls: ["./bi-archive-messages-map-toggle.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, RadioButtonModule, BiTranslateDirective]
})
export class BiArchiveMessagesMapToggleComponent {
  /**
   * Number of days back in time that user is able to see
   */
  public archiveDays: number;

  public showFromArchive = false;

  /**
   * Event fired when the toggle value has changed
   */
  @Output() toggleShowFromArchive = new EventEmitter<boolean>();
}
